import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { LABEL_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ModelSelector: FunctionComponent<Props> = ({
    className = '',
    label,
    modelLabels,
    onSelect,
    selectedModel,
    testId = TEST_ID
}) => {
    const v9ActiveClass = selectedModel === 'exedyV9' ? styles.isActive : '';
    const v12ActiveClass = selectedModel === 'exedyV12' ? styles.isActive : '';

    return (
        <VerticalContainer className={`${styles.modelSelector} ${className}`} testId={testId}>
            <Wrapper className={styles.label} testId={LABEL_TEST_ID}>
                {label}
            </Wrapper>

            <HorizontalContainer className={styles.options}>
                <Wrapper
                    className={`${styles.option} ${v9ActiveClass}`}
                    onClick={() => onSelect('exedyV9')}>
                    {modelLabels.exedyV9}
                </Wrapper>

                <Wrapper
                    className={`${styles.option} ${v12ActiveClass}`}
                    onClick={() => onSelect('exedyV12')}>
                    {modelLabels.exedyV12}
                </Wrapper>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default ModelSelector;
